export const useIsAnnotationCommentEmpty = (annotation: RevisionAnnotation) => {
  var ops = annotation.commentObject;

  if (!ops) return false;

  let comment = useConvertQuillToPlaintext(ops);

  // Replace all spaces in comment with nothing
  // If the length is 0, then the comment is empty
  comment = comment.replace(/\s/g, "");

  return comment.length == 0;
};
